import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'

export type CheckedInFilter = 'true' | 'false' | ''

type FilterState = {
  term: string
}

const initialState: FilterState = {
  term: '',
}

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    changeFilterTerm: (state, action: PayloadAction<string>) => {
      state.term = action.payload
    },
    clearFilters: state => {
      state.term = ''
    }
  }
})

export const {
  changeFilterTerm,
  clearFilters,
} = filterSlice.actions

export const getFilterTermSelector = (state: RootState) => state.filter.term

export default filterSlice.reducer
